/**
 * Feel Awsm · NAD+ Youth Elixir Funnel
 * Scoped to #feelawsm-nad-funnel (Shopify-safe, Dawn pattern).
 * Add-to-cart mirrors assets/product-form.js (sections in POST, XHR for selling plans, renderContents + open).
 */
(function () {
    "use strict";

    var ROOT_ID = "feelawsm-nad-funnel";
    var root = document.getElementById(ROOT_ID);
    if (!root) {
        return;
    }
    if (root.dataset.nyeInit === "1") {
        return;
    }
    root.dataset.nyeInit = "1";
    document.documentElement.classList.add("nye-js");

    var funnelCfg = {};
    var cfgEl = document.getElementById("FeelawsmNadFunnelConfig");
    if (cfgEl && cfgEl.textContent) {
        try {
            funnelCfg = JSON.parse(cfgEl.textContent);
        } catch (e) {
            funnelCfg = {};
        }
    }
    var addingLabel =
        funnelCfg && typeof funnelCfg.addingLabel === "string" && funnelCfg.addingLabel
            ? funnelCfg.addingLabel
            : "Adding…";

    // ============ TOAST (Step 9 — replaces alert() for cart errors) ============
    function showToast(msg, isError) {
        var existing = root.querySelector(".nye-toast");
        if (existing) { existing.remove(); }
        var t = document.createElement("div");
        t.className = "nye-toast" + (isError ? " nye-toast-err" : "");
        t.setAttribute("role", "status");
        t.setAttribute("aria-live", "polite");
        t.textContent = msg;
        root.appendChild(t);
        // Force reflow then animate in
        void t.offsetWidth;
        t.classList.add("nye-toast-in");
        setTimeout(function () {
            t.classList.remove("nye-toast-in");
            setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 320);
        }, 4200);
    }

    // ============ SCROLL REVEAL ============
    var observerOptions = { threshold: 0.1, rootMargin: "0px 0px -40px 0px" };
    var revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                entry.target.classList.add("nye-in");
                revealObserver.unobserve(entry.target);
            }
        });
    }, observerOptions);
    root.querySelectorAll(".nye-reveal").forEach(function (el) {
        revealObserver.observe(el);
    });

    // ============ FAQ ACCORDION (<details>, only one open at a time) ============
    var faqItems = root.querySelectorAll(".nye-faq-item");
    faqItems.forEach(function (item) {
        item.addEventListener("toggle", function () {
            if (item.open) {
                faqItems.forEach(function (other) {
                    if (other !== item && other.open) {
                        other.open = false;
                    }
                });
            }
        });
    });

    // ============ STICKY CART SHOW/HIDE ============
    var sticky = root.querySelector("#nye-sticky");
    var hero = root.querySelector(".nye-hero");
    var ticking = false;
    function setStickyPadding(show) {
        root.classList.toggle("nye-has-sticky", !!show);
    }
    window.addEventListener("scroll", function () {
        if (!ticking) {
            window.requestAnimationFrame(function () {
                var y = window.pageYOffset || document.documentElement.scrollTop;
                var threshold = hero ? (hero.offsetTop + hero.offsetHeight - 120) : 600;
                if (sticky) {
                    if (y > threshold) {
                        sticky.classList.add("nye-show");
                        setStickyPadding(true);
                    } else {
                        sticky.classList.remove("nye-show");
                        setStickyPadding(false);
                    }
                }
                ticking = false;
            });
            ticking = true;
        }
    }, { passive: true });

    // ============ SMOOTH ANCHOR SCROLL (offset for sticky bar) ============
    root.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
        anchor.addEventListener("click", function (e) {
            var href = anchor.getAttribute("href");
            if (!href || href.length < 2 || href === "#") {
                return;
            }
            var target = document.querySelector(href);
            if (!target) {
                return;
            }
            e.preventDefault();
            var top = target.getBoundingClientRect().top + window.pageYOffset - 60;
            window.scrollTo({ top: top, behavior: "smooth" });
        });
    });

    // ============ INGREDIENTS "SHOW ALL" TOGGLE ============
    var blocksToggle = root.querySelector(".nye-blocks-toggle button");
    var blocksWrap = root.querySelector(".nye-blocks");
    if (blocksToggle && blocksWrap) {
        blocksToggle.addEventListener("click", function () {
            var open = blocksWrap.classList.toggle("nye-show-all");
            blocksToggle.textContent = open
                ? (blocksToggle.dataset.lessLabel || "Show fewer ingredients ↑")
                : (blocksToggle.dataset.moreLabel || "See all 16 ingredients ↓");
        });
    }

    // ============ NAD+ CALCULATOR ============
    // Model: based on Zhu et al. 2015 (NAD+ ~50% lower at age 45 vs 25 in frontal cortex).
    // Lifestyle modifiers: stress, alcohol/smoking, perimenopause — all upregulate CD38/NADases
    // or oxidative depletion. NR/Resveratrol supplementation partially offsets (Trammell 2016).
    // 6 inputs: age, gender, peri/menopause, stress, smoke/heavy alcohol, current NAD+ supp.
    // Outputs: NAD+ % vs 25y baseline · estimated cellular age · tier · recommendation.
    var calcBtn = root.querySelector(".nye-calc-btn");
    if (calcBtn) {
        calcBtn.addEventListener("click", function () {
            var ageInput = root.querySelector("#nye-calc-age");
            var age = parseInt(ageInput && ageInput.value, 10);
            if (isNaN(age) || age < 18) age = 35;
            if (age > 80) age = 80;

            var gender = (root.querySelector('input[name="nye-gender"]:checked') || {}).value || "female";
            var meno = (root.querySelector('input[name="nye-meno"]:checked') || {}).value || "no";
            var stressEl = root.querySelector("#nye-calc-stress");
            var stress = (stressEl && stressEl.value) || "medium";
            var smoke = (root.querySelector('input[name="nye-smoke"]:checked') || {}).value || "no";
            var supp = (root.querySelector('input[name="nye-supp"]:checked') || {}).value || "no";

            // --- NAD+ score (% of 25y baseline) ---
            // Age decline curve: ~2.5%/yr from age 25 → ≈50% at 45, ≈68% loss at 55 (per Zhu et al.)
            var nad = 100 - Math.max(0, (age - 25) * 2.5);
            // Female biology: slightly faster decline post-35 (steeper drop in perimenopause)
            if (gender === "female" && age >= 35) nad -= 2;
            // Perimenopause / menopause — compounded NAD+ depletion via hormonal shift
            if (meno === "yes") nad -= 8;
            // Stress (chronic cortisol upregulates CD38, depletes NAD+)
            if (stress === "medium") nad -= 4;
            if (stress === "high") nad -= 10;
            // Smoking / heavy alcohol — oxidative + ethanol-driven NAD/NADH imbalance
            if (smoke === "yes") nad -= 8;
            // Currently taking NAD+ supplement — partial offset (clinical NR studies)
            if (supp === "yes") nad += 10;
            nad = Math.max(15, Math.min(100, Math.round(nad)));

            // --- Cellular age estimate ---
            // Invert the baseline curve: cellAge = 25 + (100 - nad) / 2.5
            // Shows the chronological age that would naturally have this NAD+ level.
            var cellAge = Math.round(25 + (100 - nad) / 2.5);
            var ageGap = cellAge - age;

            var scoreEl = root.querySelector("#nye-result-score");
            var catEl = root.querySelector("#nye-result-cat");
            var cellEl = root.querySelector("#nye-cellage");
            var msgEl = root.querySelector("#nye-result-msg");
            var boostEl = root.querySelector("#nye-boost");
            var fillEl = root.querySelector("#nye-prog-fill");
            var panel = root.querySelector("#nye-result");

            // Step 15: Animated counter from 0 → final value over ~900ms
            if (scoreEl) {
                var startTs = null;
                var dur = 900;
                function tick(ts) {
                    if (!startTs) startTs = ts;
                    var p = Math.min(1, (ts - startTs) / dur);
                    var eased = 1 - Math.pow(1 - p, 3); // easeOutCubic
                    scoreEl.textContent = Math.round(eased * nad) + "%";
                    if (p < 1) requestAnimationFrame(tick);
                }
                scoreEl.textContent = "0%";
                requestAnimationFrame(tick);
            }
            if (fillEl) {
                fillEl.style.width = nad + "%";
                if (nad >= 75) fillEl.style.background = "linear-gradient(90deg,#5A8A5A,#7AB87A)";
                else if (nad >= 55) fillEl.style.background = "linear-gradient(90deg,#C4973A,#E8C06A)";
                else fillEl.style.background = "linear-gradient(90deg,#B8446A,#E890B0)";
            }

            // Cellular age display (visible always)
            if (cellEl) {
                var gapText = "";
                if (ageGap >= 5) gapText = " (≈ " + ageGap + " years older than your real age)";
                else if (ageGap <= -3) gapText = " (≈ " + Math.abs(ageGap) + " years younger than your real age)";
                cellEl.textContent = "Estimated cellular age: ~" + cellAge + gapText;
            }

            var cat, msg, boost;
            if (nad >= 80) {
                cat = "🟢 Excellent NAD+ level";
                msg = "Your NAD+ is still close to a healthy 25-year-old baseline. Most women at your level haven't yet noticed the typical signs — but the slope steepens after 35. Acting now keeps you here longer.";
                boost = "💡 Recommendation: 1 capsule daily — focus on prevention. Resveratrol + CoQ10 are the most important pieces to maintain what you have. The earlier you start, the easier it is to hold.";
            } else if (nad >= 60) {
                cat = "🟡 Mild NAD+ decline";
                msg = "Your NAD+ is showing the first measurable losses. This is where subtle changes start — slower recovery from late nights, occasional brain fog, less spring in your skin. The kind of thing you write off as \"just getting older.\"";
                boost = "💡 Recommendation: 1 capsule daily for 8–12 weeks. Most women at your level report clearer thinking and steadier energy by week 4–6. The full 13-active formula matters here — single-ingredient products won't move the needle.";
            } else if (nad >= 40) {
                cat = "🟠 Significant NAD+ decline";
                msg = "Your NAD+ is well below where it should be. The effects are likely already daily — afternoon crashes, foggy mornings, hair changes, sleep that doesn't restore. Your cells are running low on the fuel they need to repair overnight.";
                boost = "💡 Recommendation: 1 capsule daily for at least 90 days — give the system time to rebuild. NR + Resveratrol + CoQ10 + BioPerine® together is the synergistic stack Sinclair himself uses. Most women see the biggest changes between weeks 6–10.";
            } else {
                cat = "🔴 Critical NAD+ depletion";
                msg = "Your NAD+ is at a level where DNA-repair and cellular energy systems are significantly impaired. This likely explains several daily things — chronic fatigue, skin/hair decline, sleep that doesn't reset you. Without active support, these compound year over year.";
                boost = "💡 Recommendation: Start now and stay consistent for 90 days minimum. The complete 13-active system is essential at this level — NR alone won't be enough without absorption (BioPerine®) and downstream activation (Resveratrol, CoQ10). 60-day guarantee gives you risk-free time to feel it.";
            }
            if (catEl) catEl.textContent = cat;
            if (msgEl) msgEl.textContent = msg;
            if (boostEl) boostEl.textContent = boost;
            if (panel) {
                panel.classList.add("nye-show");
                panel.scrollIntoView({ behavior: "smooth", block: "nearest" });
            }
        });
    }

    // ============ CART DRAWER INTEGRATION (Dawn pattern — mirrors product-form.js) ============
    function getCartUi() {
        return document.querySelector("cart-notification") || document.querySelector("cart-drawer");
    }

    function getCartAddUrl() {
        var cartAddPath =
            typeof routes !== "undefined" && routes.cart_add_url
                ? String(routes.cart_add_url)
                : "/cart/add";
        if (cartAddPath.charAt(0) === "/" && cartAddPath.indexOf("cart") !== -1) {
            return cartAddPath.replace(/\/cart\/add\/?$/, "/cart/add.js");
        }
        return "/cart/add.js";
    }

    function parseQuantity(btn) {
        var q = parseInt(btn.getAttribute("data-quantity"), 10);
        if (!isNaN(q) && q > 0) {
            return q;
        }
        return 1;
    }

    function fetchSectionHtmlForCart(cart, data, doRender) {
        if (data.sections || !cart || typeof routes === "undefined" || !routes.cart_url) {
            doRender(data);
            return Promise.resolve();
        }
        var sectionIds = cart.getSectionsToRender().map(function (s) {
            return s.id;
        });
        return Promise.all(
            sectionIds.map(function (id) {
                return fetch(routes.cart_url + "?section_id=" + id, { cache: "no-store" }).then(function (r) {
                    return r.text();
                });
            })
        )
            .then(function (htmls) {
                var sections = {};
                sectionIds.forEach(function (id, i) {
                    sections[id] = htmls[i];
                });
                doRender(Object.assign({}, data, { sections: sections }));
            })
            .catch(function () {
                doRender(data);
            });
    }

    root.querySelectorAll(".js-feelawsm-funnel-atc").forEach(function (btn) {
        btn.addEventListener("click", function (e) {
            e.preventDefault();
            if (btn.getAttribute("aria-disabled") === "true") {
                return;
            }

            var cart = getCartUi();
            var vid = parseInt(btn.getAttribute("data-variant-id"), 10);
            var spRaw = btn.getAttribute("data-selling-plan") || "";
            var quantity = parseQuantity(btn);

            if (!vid || isNaN(vid)) {
                showToast("Could not add to cart — please refresh and try again.", true);
                return;
            }

            var sellingPlanId = null;
            if (String(spRaw).trim() !== "") {
                var spNum = parseInt(spRaw, 10);
                if (!isNaN(spNum)) {
                    sellingPlanId = spNum;
                }
            }

            var item = { id: vid, quantity: quantity };
            if (sellingPlanId != null) {
                item.selling_plan = sellingPlanId;
            }

            var body = { items: [item] };
            if (cart) {
                if (typeof cart.setActiveElement === "function") {
                    cart.setActiveElement(document.activeElement);
                }
                if (sellingPlanId == null) {
                    body.sections = cart.getSectionsToRender().map(function (section) {
                        return section.id;
                    });
                    body.sections_url = window.location.pathname;
                }
            }

            var addUrl = getCartAddUrl();
            var bodyString = JSON.stringify(body);

            var previousHtml = btn.innerHTML;
            btn.innerHTML = "";
            btn.appendChild(document.createTextNode(addingLabel));
            btn.classList.add("feelawsm-funnel-atc--loading");
            btn.setAttribute("aria-busy", "true");
            btn.setAttribute("aria-disabled", "true");

            var cartAddPromise =
                sellingPlanId != null
                    ? new Promise(function (resolve, reject) {
                          var xhr = new XMLHttpRequest();
                          xhr.open("POST", addUrl, true);
                          xhr.setRequestHeader("Content-Type", "application/json");
                          xhr.setRequestHeader("Accept", "application/json");
                          xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
                          xhr.onload = function () {
                              if (xhr.status < 200 || xhr.status >= 400) {
                                  reject(new Error("Cart add failed: " + xhr.status));
                                  return;
                              }
                              try {
                                  resolve(JSON.parse(xhr.responseText));
                              } catch (err) {
                                  reject(err);
                              }
                          };
                          xhr.onerror = function () {
                              reject(new Error("Cart add network error"));
                          };
                          xhr.send(bodyString);
                      })
                    : fetch(addUrl, {
                          method: "POST",
                          headers: {
                              "Content-Type": "application/json",
                              Accept: "application/json",
                              "X-Requested-With": "XMLHttpRequest",
                          },
                          body: bodyString,
                      }).then(function (response) {
                          if (!response.ok) {
                              throw new Error("Cart add failed: " + response.status);
                          }
                          return response.json();
                      });

            cartAddPromise
                .then(function (response) {
                    if (response.status) {
                        if (typeof publish === "function" && window.PUB_SUB_EVENTS) {
                            publish(window.PUB_SUB_EVENTS.cartError, {
                                source: "feelawsm-nad-funnel",
                                productVariantId: String(vid),
                                errors: response.errors || response.description,
                                message: response.message,
                            });
                        }
                        var desc = (response.description || response.message || "Could not add to cart").toString();
                        showToast(desc, true);
                        return;
                    }

                    if (!cart) {
                        if (typeof routes !== "undefined" && routes.cart_url) {
                            window.location.href = routes.cart_url;
                        } else {
                            window.location.href = "/cart";
                        }
                        return;
                    }

                    if (typeof publish === "function" && window.PUB_SUB_EVENTS) {
                        publish(window.PUB_SUB_EVENTS.cartUpdate, {
                            source: "feelawsm-nad-funnel",
                            productVariantId: String(vid),
                            cartData: response,
                        });
                    }
                    window.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true }));

                    var doRender = function (data) {
                        cart.renderContents(data);
                    };

                    if (cart.classList && cart.classList.contains("is-empty")) {
                        cart.classList.remove("is-empty");
                    }

                    return fetchSectionHtmlForCart(cart, response, doRender);
                })
                .catch(function (err) {
                    console.warn("[feelawsm-funnel]", err);
                    var msg = (err && err.message) || "Could not add to cart";
                    showToast(msg, true);
                })
                .finally(function () {
                    btn.innerHTML = previousHtml;
                    btn.classList.remove("feelawsm-funnel-atc--loading");
                    btn.removeAttribute("aria-busy");
                    btn.removeAttribute("aria-disabled");
                });
        });
    });
})();
